import { createGlobalStyle } from 'styled-components';
import { accent } from 'constants/theme';

export default createGlobalStyle`
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }

  html {
    font-size: 62.5%;
  }

  body {
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
    line-height: 1;
    font-size: 1.6rem;
    color: #000;
    background-color: #fff;
    -webkit-text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    -webkit-font-feature-settings: "pnum";
    font-feature-settings: "pnum";
    font-variant-numeric: proportional-nums;
  }

  ol, ul {
    list-style: none;
  }

  blockquote, q {
    quotes: none;
  }

  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  a {
    color: ${accent};
  }

  pre {
    display: block;
    padding: 2rem;
    margin-top: 4rem;
    overflow: auto;
    font-size: 85%;
    line-height: 1.45;
    border-radius: 5px;
    color: ${accent};
    border: 1px solid #ddd;
    font-family: "SFMono-Regular",Consolas,"Liberation Mono",Menlo,Courier,monospace;
  }

  video {
    max-width: 100%;
  }

  p {
    margin-bottom: 2rem;
  }

  @media screen and (max-width: 1280px) {    
    .container {
      .navbar-container {
        .flexible.vertical {
          flex-direction: column;
          display: flex !important;
        }
        .navbar {
          cursor: pointer;
          display: none;
          .line {
            width: 30px;
            height: 2px;
            border-radius: 2px;
            background-color: #212121;
            margin-bottom: 6px;
            transition: all .2s linear;
          }
        }
        ul {
          display: none;
        }
        ul.ulclose {
          display: none;
        }
        .open {
          display: flex !important;
          flex-direction: column!important;
          align-items: flex-start!important;
          position: fixed;
          width: 100%;
          height: 100%;
          top: 8px;
          left: 18px;
          background-color: #fff;
          z-index: 10000;
        }
      }
    }
  }

  @media (min-width: 1200px) {
    .col-lg-4 {
      width: 33.33333%;
    }
  }

  .container {
    h5 {
      font-weight: 100;
      display: block;
      font-size: 2.2rem;
      padding: 6rem 4rem;
    }
    figcaption {
      text-align: center;
    }
    .navbar-container {
      ul {
        display: flex;
        li {
          margin: 0!important;
          padding: 23px;
          box-sizing: border-box;
        }
      }
      
      .flexible.vertical {
        flex-direction: column;
        display: none;
      }
      .flexible.horizontal {
        flex-direction: row;
      }
      .navbar {
        cursor: pointer;
        display: none;
        .line {
          width: 30px;
          height: 2px;
          border-radius: 2px;
          background-color: #212121;
          margin-bottom: 6px;
          transition: all .2s linear;
        }
      }
    }
  }

  @media screen and (min-width: 300px) and (max-width: 750px) {
    .content-container {
      width: 100% !important;
      margin: 0 auto;
      position: relative;
      .post-container {
        width: 93% !important;
        h3 {
          margin-left: 39px !important;
        }
        float: left;
        .post-warpper-container {
          width: 100% !important;
          article.list-item {
            width: 100%;
            margin: 0 2%;
            div.post-img {
              margin: 2px 23px;
              width: 100%;
              text-align: center;
            }
            div.list-content {
              margin: 2px 52px;
              overflow: initial;
              text-align: center;
              width: 84%;
              div.post-header {
                text-align: center !important;
              }
            }
          }
        }
      }
      aside.sidebar {
        width: 92% !important;
        margin: 0 15px;
      }
    }
    .container {
      aside.sidebar {
        width: 92% !important;
        margin: 0 15px;
      }
      h2 {
        width: 100% !important;
        float: left;
        padding: 2rem 0 6rem;
      }
      h2.post-title {
        width: 85% !important;
        float: left;
        font-weight: 100;
        display: block;
        font-size: 2.2rem;
        padding: 10px 28px;
      }
      .post-page-wrapper {
        h3 {
          width: 90%;
          float: left;
          margin: 20px 26px;
        }
        span.cat {
          width: 90%;
          float: left;
          margin: 0 13px;
        }
        width: 100% !important;
        float:left;
        .category-wrapper, .content-wrapper {
          width: 90%;
          float: left;
          margin: 0 15px;
          padding: 0;
          display: block;
          box-sizing: border-box;
          -webkit-font-smoothing: antialiased;
          color: #424242;
          font-size: 14px;
        }
        .content-wrapper {
          .post-wrapper {
            width: 95%;
            float: left;
            margin-left: 11px;
            p {
              line-height: 2em;
            }
          }
        }
      }
    }
    
    .bvOGEZ {
      width: 100% !important;
      .cEvGDW {
        margin-left: 39px;
      }
      .eCFqsP {
        article.list-item {
          width: 100%;
          margin: 0 2%;
          div.post-img {
            margin: 2px 23px;
            width: 100%;
            text-align: center;
          }
          div.list-content {
            margin: 2px 52px;
            overflow: initial;
            text-align: center;
            width: 84%;
            div.post-header {
              text-align: center !important;
            }
          }
        }
      }
    }

    .fxlTGy {
      width: 100% !important;
      float: left !important;
    }
  }
`;
